export default __webpack_public_path__ + "224cc159d488d154053675e8cdff78a7.svg";